import { render, staticRenderFns } from "./EventDetail.vue?vue&type=template&id=fbd5818e&scoped=true&"
import script from "./EventDetail.vue?vue&type=script&lang=js&"
export * from "./EventDetail.vue?vue&type=script&lang=js&"
import style0 from "./EventDetail.vue?vue&type=style&index=0&id=fbd5818e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.5_@vue+compiler-sfc@3.5.44_babel-core@7.0.0-bridge.0_@babel+core@7.12.8_bab05b83ea19148beb1746204d3ff44c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd5818e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbd5818e')) {
      api.createRecord('fbd5818e', component.options)
    } else {
      api.reload('fbd5818e', component.options)
    }
    module.hot.accept("./EventDetail.vue?vue&type=template&id=fbd5818e&scoped=true&", function () {
      api.rerender('fbd5818e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/calendar/components/EventDetail.vue"
export default component.exports